import { res } from "@/BaseComponent";
import { apiService, header } from "@/services/interceptor";
export default {
    async getList(page: number, size: number, filterList: any, smIdx: number | null): Promise<res> {
        const res = {} as res;
        try {
            header.headers["Content-Type"] = "application/json";
            const response = await apiService().post(
                "/trace/history",
                {
                    page,
                    size,
                    searchType: filterList.searchType,
                    sns: filterList.sns,
                    type: filterList.type,
                    resultType: filterList.resultType,
                    resultDetailType: filterList.resultDetailType,
                    nation: filterList.nation,
                    searchContent: filterList.searchContent,
                    smIdx: smIdx ? smIdx : null,
                },
                { withCredentials: false },
            );
            return response.data;
        } catch (error) {
            res.returnCode = -1;
            console.info(error);
        }
        return res;
    },
};
